import { WaterMarkProps } from '../component/waterMark/WaterMark'


export interface Config {
    appId?: string;                                     // 平台id
    menus?: string;                                     // 文件上传目标路径
    getCopyBlockDisabled?: () => boolean;               // 是否停用禁止复制功能
    getWaterMarkProps?: () => WaterMarkProps | any;     // 获取水印参数
}


/**
 * 公共模块配置
 */
class CommonConfig {
    appId: string;
    menus: string;
    getCopyBlockDisabled = (): boolean => false;
    getWaterMarkProps = (): WaterMarkProps | any => { };

    config(options: Config) {
        const {
            appId = '',
            menus = '',
            getCopyBlockDisabled = () => false,
            getWaterMarkProps = () => { },
        } = options;

        this.appId = appId;
        this.menus = menus;
        this.getCopyBlockDisabled = getCopyBlockDisabled;
        this.getWaterMarkProps = getWaterMarkProps;
    }
}


const commonConfig = new CommonConfig();
export default commonConfig;
